import axios from "axios";
let timeoutCallbacks = null;
let isRedirecting = false;

// Reset flag on every fresh page load
window.addEventListener('load', () => { isRedirecting = false; });

export const setTimeoutResetCallback = (callbacks) => {
    timeoutCallbacks = callbacks;
};

axios.interceptors.request.use(
    config => {

        if (timeoutCallbacks?.pauseTimeout) {
            timeoutCallbacks.pauseTimeout();
        }

        const token = sessionStorage.getItem('Token');
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
        }

        // Don't set Content-Type for FormData - let axios handle it automatically
        if (config.data instanceof FormData) {
            delete config.headers['Content-Type'];
        }

        return config;
    },
    error => {
        Promise.reject(error)
    });


axios.interceptors.response.use((response) => { // block to handle success 
    if (timeoutCallbacks?.resumeTimeout) {
        timeoutCallbacks.resumeTimeout();
    } 
    
    return response
}, function (error) { // block to handle error case

    if (timeoutCallbacks?.resumeTimeout) {
        timeoutCallbacks.resumeTimeout();
    }

    console.log("error in interceptor", error, error.response?.data.message)

    if (error.response?.status === 401) {
        const message = error.response?.data?.Message || "";
        const isConcurrentLogin = message === "CONCURRENT_LOGIN";
        const hadToken = !!sessionStorage.getItem('Token');
        const wasLoggedIn = sessionStorage.getItem('isLoggedIn') === 'true';

        if (isConcurrentLogin && !isRedirecting) {
            isRedirecting = true;
            window.alert("Your session has been ended because you logged in from another device.");
            sessionStorage.clear();
            if (timeoutCallbacks?.forceLogout) {
                timeoutCallbacks.forceLogout();
            } else {
                window.location.href = "/";
            }
        } else if (!isConcurrentLogin && hadToken && wasLoggedIn && !isRedirecting) {
            // Token expired or invalid — silent redirect, no alert
            isRedirecting = true;
            sessionStorage.clear();
            if (timeoutCallbacks?.forceLogout) {
                timeoutCallbacks.forceLogout();
            } else {
                window.location.href = "/";
            }
        }
        // 401 during login flow (no token/not logged in) — do nothing, let login handle it
        return Promise.reject(error.response);
    }

    if (error.response?.status === 429) {
        const retryAfter = error.response.data?.retryAfter;
        const message = retryAfter
            ? `Too many requests. Please try again in ${retryAfter} minute(s).`
            : 'Too many requests. Please try again later.';
        window.alert(message);
        return Promise.reject(error.response);
    }

    if (error) {
        return Promise.reject(error.response);
    }

    return Promise.reject("Unable to process request");
});
